$(function () {
  var select_data = data_attributes();
  postData(select_data);

  $(".block_shipping_date input[type='radio']").on('input', function () {
    var select_data = data_attributes();
    postData(select_data);
  })
  $(".block_shipping_date input[type='text']").on('input', function () {
    var select_data = data_attributes();
    postData(select_data);
  })
  $(".block_shipping_date select").on('change', function () {
    var select_data = data_attributes();
    postData(select_data);
  })
  $(".block_shipping_date textarea").on('input', function () {
    var select_data = data_attributes();
    postData(select_data);
  })

  function data_attributes() {
    var text_memo = "";
    // のし
    var text_noshi = $("#option_noshi option:selected").val();
    if (text_noshi !== "不要") {
      var text_memo = text_memo + ' 商品名欄あり';
    } else {
      var text_memo = text_memo + '';
    }

    // 配達希望日
    var text_shipping_date = $('#option_shipping_date option:selected').val();

    // 配達希望時間
    var text_shipping_time = $('#option_shipping_time option:selected').val();

    // 領収書の有無
    var text_receipt_flag = $("#option_receipt_flag:checked").val();
    if (text_receipt_flag == '要') {
      var text_memo = text_memo + ' 領収書あり';
    }

    // 領収書の宛名
    var text_receipt = $('#option_receipt_name').val();
    if (text_receipt.length !== 0) {
      // ある場合
      var text_receipt = $('#option_receipt_name').val();
    } else {
      // ない場合
      var text_receipt = "";
    }

    // ご要望・備考
    var text_note = $('#option_note').val();
    if (text_note.length !== 0) {
      // ある場合
      var text_note = $('#option_note').val();
    } else {
      // ない場合
      var text_note = "";
    }

    const attributes = {
      note: text_memo,
      attributes: {
        '贈る方にお伝えしたい内容': text_noshi,
        '配達希望日': text_shipping_date,
        '配達希望時間': text_shipping_time,
        '領収書の有無': text_receipt_flag,
        '領収書の宛名': text_receipt,
        'ご注文に関するご要望・備考': text_note,
      }
    };
    return attributes;
  }
  function postData(attributes) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(attributes),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Success:', data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

})